import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { FieldsetToggleComponent } from "@components/fieldset-toggle/fieldset-toggle.component";
import { InputNumberComponent } from "@components/input-number/input-number.component";
import { ITplHandelssortiment } from "../../../models/dtos";
import { FilterBaseComponent } from "../filter-base-component";
import { TplFilterContext } from "../tpl-filter-context";
import { IMinMax, ITplHandelssortimentFilter } from "../tpl-filter.models";

@Component({
    selector: "rask-tpl-volym-filter",
    templateUrl: "./tpl-volym-filter.component.html",
    styleUrls: ["./tpl-volym-filter.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FieldsetToggleComponent,
        FormsModule,
        ReactiveFormsModule,
        InputNumberComponent
    ]
})
export class TplVolymFilterComponent extends FilterBaseComponent implements OnInit, ITplHandelssortimentFilter {

    private isVaglager: boolean;

    constructor() {
        super("volym");
    }

    ngOnInit(): void {
        this.onFormInit(new UntypedFormGroup({
            min: new UntypedFormControl(null),
            max: new UntypedFormControl(null)
        }));
    }

    onFilterInit(state: IMinMax): void {
        state = state ?? { min: null,
            max: null };
        this.control.setValue(state);
    }

    match(item: ITplHandelssortiment): boolean {
        const value = this.value();

        if (this.isVaglager) {
            return this.isBetween(item.vagVolym, value.min, value.max);
        }

        return this.isBetween(item.planeradVolym, value.min, value.max);
    }

    value(): IMinMax {
        return this.control.value;
    }

    isActive(): boolean {
        return this.filterLength > 0;
    }

    prepare(): void {
        this.isVaglager = this.filterContext.isVaglagerActive();
    }

    protected onAddFilterToContext(filterContext: TplFilterContext) {
        filterContext.addHandelssortimentFilter(this.name, this);
    }

    protected onFormChange(value: IMinMax): void {
        this.filterLength = (value.min ? 1 : 0) + (value.max ? 1 : 0);
    }
}
